// Copy the kit area's screens and components added while moving to the design system (src/ui).
// One entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const kitCopy = {
  nl: {
    "route.error.title": "Hier ging iets mis",
    "route.error.body":
      "Dit scherm kon niet worden getoond. Je gegevens zijn niet kwijt; probeer het opnieuw of ga terug naar het begin.",
    "route.error.retry": "Opnieuw proberen",
    "route.error.home": "Terug naar het begin",
  },
  en: {
    "route.error.title": "Something went wrong here",
    "route.error.body":
      "This screen could not be shown. Nothing of yours is lost; try again or head back to the start.",
    "route.error.retry": "Try again",
    "route.error.home": "Back to start",
  },
  de: {
    "route.error.title": "Hier ist etwas schiefgelaufen",
    "route.error.body":
      "Dieser Bildschirm ließ sich nicht anzeigen. Deine Daten sind noch da; versuch es noch einmal oder geh zurück zum Anfang.",
    "route.error.retry": "Noch einmal versuchen",
    "route.error.home": "Zurück zum Anfang",
  },
  fr: {
    "route.error.title": "Quelque chose s'est mal passé ici",
    "route.error.body":
      "Cet écran n'a pas pu s'afficher. Tes données sont intactes ; réessaie ou reviens au début.",
    "route.error.retry": "Réessayer",
    "route.error.home": "Retour au début",
  },
  es: {
    "route.error.title": "Algo ha salido mal aquí",
    "route.error.body":
      "No se ha podido mostrar esta pantalla. No has perdido nada; inténtalo de nuevo o vuelve al inicio.",
    "route.error.retry": "Intentar de nuevo",
    "route.error.home": "Volver al inicio",
  },
  it: {
    "route.error.title": "Qui qualcosa è andato storto",
    "route.error.body":
      "Non è stato possibile mostrare questa schermata. I tuoi dati sono al sicuro; riprova o torna all'inizio.",
    "route.error.retry": "Riprova",
    "route.error.home": "Torna all'inizio",
  },
  pt: {
    "route.error.title": "Algo correu mal aqui",
    "route.error.body":
      "Não foi possível mostrar este ecrã. Não perdeste nada; tenta outra vez ou volta ao início.",
    "route.error.retry": "Tentar outra vez",
    "route.error.home": "Voltar ao início",
  },
} as const;
